import styled from "styled-components";

export const Wrapper = styled.div`
  border-radius: 10px;
  background: #f1f5f9;
  padding: 3px;
  font-family: Maison Neue;
  font-weight: 600;
  font-size: 13px;
  line-height: 19.5px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  flex-shrink: 0;

  @media (max-width: 480px) {
    border-radius: 8px;
    padding: 2px;
    font-size: 11px;
    line-height: 16px;
  }
`;

export const LocalWrapper = styled.div`
  padding: 4px 10px;
  background: ${({ isActive }) => (isActive ? "#fff;" : "none")};
  border-radius: ${({ isActive }) => (isActive ? "8px;" : "initial")};
  color: ${({ isActive }) => (isActive ? "#374151;" : "#64748b")};
  cursor: ${({ isActive }) => (isActive ? "initial;" : "pointer")};

  @media (max-width: 480px) {
    padding: 3px 7px;
    border-radius: ${({ isActive }) => (isActive ? "6px;" : "initial")};
  }

  @media (max-width: 360px) {
    padding: 3px 6px;
  }
`;
